import { useEffect, useRef } from 'react';

const CLOSE_OPEN_MODALS_EVENT = 'myriad:close-open-modals';

export const closeOpenModals = () => window.dispatchEvent(new Event(CLOSE_OPEN_MODALS_EVENT));

export const useCloseOnOpenModalsEvent = (isOpen, close) => {
  const closeRef = useRef(close);
  closeRef.current = close;

  useEffect(() => {
    if (!isOpen) return;

    const handleEvent = () => closeRef.current?.();
    window.addEventListener(CLOSE_OPEN_MODALS_EVENT, handleEvent);
    return () => window.removeEventListener(CLOSE_OPEN_MODALS_EVENT, handleEvent);
  }, [isOpen]);
};
